import { Injectable } from '@angular/core';
import { Events } from 'ionic-angular';
import 'rxjs/add/operator/map';
import { AngularFire, FirebaseListObservable } from 'angularfire2';
import { BeaconModel } from "../models/beacon-module";

/*
  Generated class for the Databaseservice provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class Databaseservice {
    
  beacons: BeaconModel[] = [];
  nearbyCorners: FirebaseListObservable<any[]>;

  constructor(private af: AngularFire, public events: Events) {
    console.log('Hello Databaseservice Provider');
    this.getBeaconList();
  }

  public listAccounts(): FirebaseListObservable<any[]> {
    return this.af.database.list('/accounts');
  }

  public listNearbyCorners(): FirebaseListObservable<any[]> {
    console.log(JSON.stringify(this.beacons)); 
      for (let beaconitem of this.beacons){
          this.nearbyCorners = this.af.database.list('/accounts', {
            query: {
                orderByChild: 'beaconmajor',
                equalTo: beaconitem.major //Hier komt de beacon major
            }
            });
          //this.nearbyCorners.push(cornerObject);

      }
    return this.nearbyCorners;
  }
    
  getBeaconList(){
    this.events.subscribe('didRangeBeaconsInRegion',
            (publishBeacons) => {
              this.beacons = publishBeacons;
            })
  }

}


// WEBPACK FOOTER //
// ./src/providers/databaseservice.ts